"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.textSeparators = void 0;
exports.textSeparators = ",;";
